export function normalizePath(input: string) {
  let path = input.trim();
  try {
    path = decodeURI(path);
  } catch {
    // Preserve malformed legacy encodings for exact matching.
  }
  path = path.split("?")[0].split("#")[0];
  // Clean up relative path prefixes like ../ or ./ to resolve correctly to root
  path = path.replace(/^(\.\.\/|\.\/)+/, "");
  if (!path.startsWith("/")) path = `/${path}`;
  path = path.replace(/\/{2,}/g, "/");
  if (path !== "/" && !path.startsWith("/blog/") && path.endsWith("/")) path = path.slice(0, -1);
  return path;
}

const PUBLIC_PATH_EXCLUSIONS = [
  "/api/",
  "/media/",
  "/upload/",
  "/blog/wp-content/uploads/",
  "/_next/",
];

const LEGACY_ENDPOINTS = new Set([
  "/make-an-appointment.php",
]);

export function stripFinalPhpExtension(pathname: string) {
  return pathname.replace(/\.php$/i, "");
}

export function isPublicLegacyPhpPagePath(pathname: string) {
  const normalized = normalizePath(pathname);
  if (!/\.php$/i.test(normalized)) return false;
  if (LEGACY_ENDPOINTS.has(normalized.toLowerCase())) return false;
  return !PUBLIC_PATH_EXCLUSIONS.some((prefix) => normalized.toLowerCase().startsWith(prefix));
}

export function publicPagePath(pathname: string) {
  const normalized = normalizePath(pathname);
  return isPublicLegacyPhpPagePath(normalized) ? stripFinalPhpExtension(normalized) : normalized;
}

export function publicUrl(value?: string | null) {
  if (!value || value === "#") return value || "";
  if (/^(mailto:|tel:|whatsapp:|sms:|javascript:)/i.test(value)) return value;
  try {
    const url = new URL(value);
    if (/^(www\.)?dermalife\.co\.in$/i.test(url.hostname)) {
      const pathname = publicPagePath(url.pathname);
      return `${pathname}${url.search}${url.hash}`;
    }
    return url.toString();
  } catch {
    const [pathAndQuery, hash = ""] = value.split("#", 2);
    const [pathname, query = ""] = pathAndQuery.split("?", 2);
    const nextPath = publicPagePath(pathname);
    return `${nextPath}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`;
  }
}

export function searchParamsToString(searchParams: Record<string, string | string[] | undefined>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(searchParams)) {
    if (Array.isArray(value)) {
      for (const item of value) params.append(key, item);
    } else if (typeof value === "string") {
      params.set(key, value);
    }
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const HAIR_CASE_BASE_PATH = "/results/male-hair-transplant";

export function slugifyCategory(title: string) {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

// Public URL of a hair transplant case: /results/male-hair-transplant/<category>/<slug>.
export function hairCasePath(category: string | null | undefined, slug: string) {
  return `${HAIR_CASE_BASE_PATH}/${category ? slugifyCategory(category) : "case"}/${slug.replace(/^\/+|\/+$/g, "")}`;
}
